export const ACCOUNT_SHOW_RESET = 'ACCOUNT_SHOW_RESET'
export const ACCOUNT_SHOW_SET_ERROR = 'ACCOUNT_SHOW_SET_ERROR'
export const ACCOUNT_SHOW_SET_RETRIEVED = 'ACCOUNT_SHOW_SET_RETRIEVED'
export const ACCOUNT_SHOW_TOGGLE_LOADING = 'ACCOUNT_SHOW_TOGGLE_LOADING'
